import * as ng from 'angular';
import { ArchiSmallServices } from '../../../services/archismall.service';

export class RegistrationTypeController implements ng.IController {

    static $inject: string[] = [
        '$state',
        '$rootScope',
        '$scope',
        'store',
        'ArchiSmallServices'
    ];


    constructor(
        private $state: ng.ui.IStateService,
        private $rootScope: any,
        private $scope: any,
        private store: ng.a0.storage.IStoreService,
        private ArchiSmallServices: ArchiSmallServices
    ) {

        $scope.pageHeader = 'Registrazione Utente';
        $scope.tooltips = {
            'registrazioneUtente': 'Seleziona il profilo in base alla tua attività',
            'liberoProfessionista': 'Lavoratore autonomo, lavoratore subordinato, professionista con Partita IVA'
        };

        if (!$scope.$parent.$parent.init()) {
            return;
        }

        if (store.get('registeringUser')) {
            $scope.user = store.get('registeringUser');
        }

        $scope.next = (userType) => {
            $scope.user.accountData.lastStepSaved = 'account-data';
            $scope.user.accountData.userType = userType;

            switch ($scope.user.accountData.userType) {
                case 1:
                    $scope.user.accountData.userTypeName = 'Libero Professionista';
                    break;
                case 2:
                    $scope.user.accountData.userTypeName = 'Ditta Individuale';
                    break;
                case 3:
                    $scope.user.accountData.userTypeName = 'Azienda';
                    break;
            }

            store.set('registeringUser', $scope.user);
            $state.go('registration.account-data');
        };
    }
}



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/registration-type/registration-type.controller.ts